<template>
  <div id="app-container">
    <AppTopBar
      :username="userInfo.username || 'admin'"
      :show-admin="userInfo.rol === 'admin' || userInfo.rol === 'superadmin'"
      :show-logout="true"
      :show-vista-toggle="true"
      :vista-actual="vistaActual"
      :conteo-marketplace="conteoVistas.marketplace"
      :conteo-web="conteoVistas.web"
      @logout="logout"
      @change-vista="cambiarVista"
    />

    <div class="home-content">
      <!-- KPIs banda -->
      <KPIPanel :kpis="overviewKPIs" @verLista="() => {}" />

      <!-- Fila 1: Line Competitividad (ancho) + Score Salud (chico) -->
      <div class="charts-row charts-row-1">
        <ChartCompetitividad :vista="vistaActual" />
        <ChartScoreSalud :vista="vistaActual" />
      </div>

      <!-- Fila 2: Por tienda + Por categoría + Top competidores -->
      <div class="charts-row charts-row-2">
        <ChartDistribucionTienda :vista="vistaActual" />
        <ChartDistribucionCategoria :vista="vistaActual" />
        <ChartTopCompetidores :vista="vistaActual" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, watch } from 'vue';
import { useRouter } from 'vue-router';
import axios from 'axios';

import AppTopBar from '../components/AppTopBar.vue';
import KPIPanel from '../components/KPIPanel.vue';
import ChartCompetitividad from '../components/charts/ChartCompetitividad.vue';
import ChartScoreSalud from '../components/charts/ChartScoreSalud.vue';
import ChartDistribucionTienda from '../components/charts/ChartDistribucionTienda.vue';
import ChartDistribucionCategoria from '../components/charts/ChartDistribucionCategoria.vue';
import ChartTopCompetidores from '../components/charts/ChartTopCompetidores.vue';

const router = useRouter();
const API_BASE_URL = 'https://dash-visaovip.kompara.tech/api';

const getAuthHeaders = () => {
  const token = localStorage.getItem('token_precios');
  return { headers: { Authorization: `Bearer ${token}` } };
};

const userInfo = ref({ username: '', rol: '' });
const vistaActual = ref(localStorage.getItem('vista_actual') || 'web');
const overviewKPIs = ref({});
const conteoVistas = ref({ web: 0, marketplace: 0 });

const cambiarVista = (nuevaVista) => {
  vistaActual.value = nuevaVista;
  localStorage.setItem('vista_actual', nuevaVista);
};

const logout = () => {
  localStorage.removeItem('token_precios');
  router.push('/');
  window.location.reload();
};

const loadKPIs = async () => {
  try {
    const res = await axios.get(`${API_BASE_URL}/kpis/overview`, {
      ...getAuthHeaders(),
      params: { vista: vistaActual.value }
    });
    overviewKPIs.value = res.data;
    conteoVistas.value[vistaActual.value] = res.data.competitive_products_count || 0;
  } catch (err) {
    console.error('Error cargando KPIs:', err);
  }
};

const loadConteoOtraVista = async () => {
  const otraVista = vistaActual.value === 'web' ? 'marketplace' : 'web';
  try {
    const res = await axios.get(`${API_BASE_URL}/kpis/overview`, {
      ...getAuthHeaders(),
      params: { vista: otraVista }
    });
    conteoVistas.value[otraVista] = res.data.competitive_products_count || 0;
  } catch (err) {
    // Silencioso
  }
};

watch(vistaActual, () => {
  loadKPIs();
});

onMounted(async () => {
  // Decodificar usuario del JWT
  const token = localStorage.getItem('token_precios');
  if (!token) {
    router.push('/');
    return;
  }
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    userInfo.value = { username: payload.sub || 'admin', rol: payload.rol || 'admin' };
  } catch { /* ignore */ }

  await loadKPIs();
  loadConteoOtraVista();
});
</script>

<style scoped>
#app-container {
  min-height: 100vh;
  background: var(--color-background);
  color: var(--color-text);
}

.home-content {
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-width: 1800px;
  margin: 0 auto;
}

/* Filas de gráficos */
.charts-row {
  display: grid;
  gap: 12px;
}
.charts-row-1 {
  grid-template-columns: 2fr 1fr;
}
.charts-row-2 {
  grid-template-columns: 1fr 1fr 1fr;
}

@media (max-width: 1100px) {
  .charts-row-1, .charts-row-2 {
    grid-template-columns: 1fr;
  }
}
</style>